import { Machine, assign } from 'xstate';
import { wpFetchRestApi, isWpSuccess } from '../../util';
import Cookies from "js-cookie";
export const INDICATOR_RESOLUTION = 360;
;
const assignMeetingInfo = assign({
    meetingInfo: (__, event) => event.data,
    error: () => undefined,
});
const assignIndicatorAndClearError = assign({
    indicator: (ctx, __) => (ctx.indicator + 1) % INDICATOR_RESOLUTION,
    error: () => undefined,
});
export const participantVideoMeetingMachine = Machine({
    id: "participant-video-meeting",
    initial: 'unknown',
    states: {
        unknown: {
            id: 'unknown',
            always: [
                { target: 'waiting_to_start', cond: 'meetingNotStarted' },
                { target: 'in_progress', cond: 'meetingInProgress' },
                { target: 'finished', cond: 'meetingFinished' },
                { target: 'cancelled', cond: 'meetingCancelled' },
            ],
        },
        waiting_to_start: {
            initial: 'idle',
            states: {
                idle: {
                    after: {
                        2000: 'checking_status',
                    }
                },
                checking_status: {
                    invoke: {
                        id: 'fetch-meeting-info',
                        src: 'fetchMeetingInfo',
                        onDone: [
                            {
                                target: 'idle',
                                cond: 'isEventStateWaiting',
                                actions: assignIndicatorAndClearError,
                            },
                            {
                                target: '#in-progress',
                                actions: assignMeetingInfo,
                                cond: 'isEventStateInProgress',
                            },
                            {
                                target: '#finished',
                                actions: assignMeetingInfo,
                                cond: 'isEventStateFinished',
                            },
                            {
                                target: '#cancelled',
                                actions: assignMeetingInfo,
                                cond: 'isEventStateCancelled',
                            },
                        ],
                        onError: {
                            target: 'status_check_failed',
                            actions: assign({
                                // @ts-ignore
                                error: (__, evt) => evt.data,
                            }),
                        }
                    },
                },
                status_check_failed: {
                    after: {
                        10000: 'checking_status',
                    },
                },
            },
        },
        in_progress: {
            id: 'in-progress',
            type: 'parallel',
            states: {
                checking_meeting_state: {
                    initial: 'idle',
                    states: {
                        idle: {
                            after: {
                                2000: 'checking_state',
                            }
                        },
                        checking_state: {
                            invoke: {
                                id: 'checking-meeting-state-in-progress',
                                src: 'fetchMeetingInfo',
                                onDone: [
                                    {
                                        target: 'idle',
                                        cond: isEventState('in_progress'),
                                    },
                                    {
                                        target: '#unknown',
                                        actions: assignMeetingInfo,
                                    }
                                ],
                                onError: {
                                    target: 'status_check_failed',
                                },
                            }
                        },
                        status_check_failed: {
                            after: {
                                2000: 'checking_state',
                            },
                        },
                    }
                },
                meeting: {
                    id: 'meeting',
                    initial: 'not_joined',
                    states: {
                        not_joined: {
                            on: {
                                JOIN: 'joined',
                            },
                            initial: 'unknown',
                            states: {
                                unknown: {
                                    always: [
                                        {
                                            target: 'first_time',
                                            cond: noCookieFound,
                                            actions: setCookie,
                                        },
                                        { target: 'previously_joined' },
                                    ],
                                },
                                first_time: {},
                                previously_joined: {
                                    on: {
                                        FEEDBACK: '#feedback',
                                    }
                                },
                            }
                        },
                        joined: {
                            on: {
                                LEAVE: 'hangup',
                            }
                        },
                        hangup: {
                            on: {
                                JOIN: 'not_joined',
                                FEEDBACK: '#feedback',
                            },
                        },
                    }
                },
            }
        },
        finished: {
            id: 'finished',
            on: {
                FEEDBACK: '#feedback',
            }
        },
        cancelled: {
            id: 'cancelled',
        },
        feedback: {
            id: 'feedback',
            entry: [
                'redirectToFeedback',
            ],
        },
    },
}, {
    guards: {
        'meetingNotStarted': isContextState("waiting_to_start"),
        'meetingInProgress': isContextState("in_progress"),
        'meetingFinished': isContextState("finished"),
        'meetingCancelled': isContextState("cancelled"),
        'isEventStateWaiting': isEventState('waiting_to_start'),
        'isEventStateInProgress': isEventState('in_progress'),
        'isEventStateFinished': isEventState('finished'),
        'isEventStateCancelled': isEventState('cancelled'),
    },
    services: {
        'fetchMeetingInfo': fetchMeetingInfo,
    },
    actions: {
        'showFeedback': () => { },
        'hideFeedback': () => { },
        'redirectToFeedback': redirectToFeedback,
    },
});
export const createMachine = (meetingInfo, feedbackPage) => {
    return participantVideoMeetingMachine.withContext({ meetingInfo, feedbackPage, indicator: 0 });
};
function redirectToFeedback(ctx) {
    window.location.href = ctx.feedbackPage;
}
;
async function fetchMeetingInfo(context) {
    const endpoint = 'client-meeting-info/' + context.meetingInfo.room_name;
    const result = await wpFetchRestApi(endpoint, 'GET');
    if (isWpSuccess(result)) {
        return result.data;
    }
    throw new Error(result.message);
}
function isContextState(state) {
    return (ctx) => ctx.meetingInfo.state == state;
}
function isEventState(state) {
    return (__, e) => e.data.state == state;
}
function noCookieFound(ctx) {
    return !cookieFound(ctx);
}
function cookieFound(ctx) {
    const cookieName = "joined-" + ctx.meetingInfo.room_name;
    const cookieValue = Cookies.get(cookieName);
    return cookieValue != undefined;
}
function setCookie(ctx) {
    const cookieName = "joined-" + ctx.meetingInfo.room_name;
    const cookieValue = "true";
    Cookies.set(cookieName, cookieValue);
}
